import { AnyAction, Dispatch } from "redux";
import { Actions } from "./index";
import { SSOApi } from "@eres/ssoapi";
import { getUser, refreshTabuProfile, setSSOUser, setTabuUser } from "@my-dld/utils/User";
import { SSOProfile } from "@10x/sso/SSOProfile";
import { isLoggedIn } from "@10x/sso";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { getAppServices } from "@10x/coreapp/index";
import { IdentityApi } from "@10x/dubai-rest-api";

export function logout() {
	return ( dispatch: Dispatch ) => {
		dispatch( {
			type: Actions.USER_LOGGED_OUT,
		} );
	};
}

export function login( user: any ) {
	return ( dispatch: Dispatch ) => {
		dispatch( {
			type: Actions.USER_LOGGED_IN,
			payload: user,
		} );
	};
}

function ssoRefresh( dispatch: Dispatch<AnyAction> ) {
	SSOApi.silentTokenRefresh( profile => {
		if ( ( profile as any ).error == null ) {
			setSSOUser( profile );
		}
		dispatch( {
			type: Actions.USER_REFRESHING,
			payload: false,
		} );
	}, error => {
		const u = getUser();
		let ssoP = SSOProfile.getProfile();
		if ( u && ssoP ) {
			u.removeProfile( ssoP );
		}
		dispatch( {
			type: Actions.USER_REFRESHING,
			payload: false,
		} );
	} );
}

function tabuRefresh( dispatch: Dispatch<AnyAction> ) {
	refreshTabuProfile( profile => {
		setTabuUser( profile );
		dispatch( {
			type: Actions.USER_REFRESHING,
			payload: false,
		} );
	}, error => {
		const u = getUser();
		let ssoP = TabuProfile.getProfile();
		if ( u && ssoP ) {
			u.removeProfile( ssoP );
		}
		dispatch( {
			type: Actions.USER_REFRESHING,
			payload: false,
		} );
	} );
}


function guestTokenRefresh( dispatch: Dispatch<AnyAction> ) {
	IdentityApi.guestAuthenticate().then( () => {
	} ).catch();
}

export function refreshUser() {
	return ( dispatch: Dispatch ) => {
		if ( !getAppServices().storeService.getStore().getState().TempData.isRefreshing ) {
			dispatch( {
				type: Actions.USER_REFRESHING,
				payload: true,
			} );
			if ( isLoggedIn() ) {
				const tabu = TabuProfile.getProfile();
				if ( tabu ) {
					tabuRefresh( dispatch );
				} else {
					guestTokenRefresh( dispatch );
					ssoRefresh( dispatch );
				}
			} else {
				guestTokenRefresh( dispatch );
				ssoRefresh( dispatch );
			}

		}

	};
}
